import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { ConfigService } from '@finder/core/config.service';
import { SfccConnector } from './sfcc-connector';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/config.service";
import * as i2 from "@angular/common/http";
export class SfccGenericConnectorService extends SfccConnector {
    constructor(config, http) {
        super(config, http);
        this.config = config;
        this.http = http;
    }
    auth(type = 'session') {
        // Get the URL and call
        const apiBase = this.getApiBase();
        const url = `${apiBase}/shop/auth`;
        const options = this.getOptions();
        options.body = { type: type };
        return this.http.post(url, options);
    }
    addProducts(skus) {
        return throwError(new Error('Not Implemented'));
    }
    addProduct(product) {
        // Get the URL and call
        const apiBase = this.getApiBase();
        const url = `${apiBase}/shop/cart/${product.cartId}`;
        return this.cartAddBase(product, url);
    }
    updateProduct(product) {
        // Create the body
        const body = {
            qty: product.qty,
        };
        // Get the URL and call
        const apiBase = this.getApiBase();
        const url = `${apiBase}/shop/cart/${product.cartId}/${product.itemId}`;
        return this.http.patch(url, body, this.getOptions());
    }
    removeProduct(product) {
        // Get the URL and call
        const apiBase = this.getApiBase();
        const url = `${apiBase}/shop/cart/${product.cartId}/${product.itemId}`;
        return this.http.delete(url, this.getOptions());
    }
    createCartWithProduct(product) {
        // Get the URL and call
        const apiBase = this.getApiBase();
        const url = `${apiBase}/shop/cart`;
        return this.cartAddBase(product, url);
    }
    cartAddBase(product, url) {
        // Create the body
        const body = [
            {
                productId: product.productId,
                qty: product.qty
            }
        ];
        return this.http.post(url, body, this.getOptions());
    }
    getOptions() {
        return {
            headers: new HttpHeaders({
                'content-type': 'application/json',
            }),
            withCredentials: true,
        };
    }
}
SfccGenericConnectorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SfccGenericConnectorService_Factory() { return new SfccGenericConnectorService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.HttpClient)); }, token: SfccGenericConnectorService, providedIn: "root" });
